export default __webpack_public_path__ + "static/media/Cryptopayments.9c4ec41e.png";